import { inject } from '@angular/core';
import {
  CanActivateFn,
  CanMatchFn,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSegment,
  Router
} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn & CanMatchFn = async (
  route: ActivatedRouteSnapshot | Route,
  state: RouterStateSnapshot | UrlSegment[]
) => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  const _isAuthenticated = await _authService.isAuthenticated();

  if (!_isAuthenticated) {
    const _redirectPath =
      state instanceof RouterStateSnapshot
        ? state.url
        : Array.isArray(state)
          ? '/' + state.map(s => s.path).join('/')
          : '/';

    _router.navigate(['/login'], { queryParams: { redirect: _redirectPath } });
    return false;
  }

  return true;
};
